import { DELETE_SCHEDULED_DEPLOYMENT } from "fleet/redux-store/scheduled-deployments/actions";
import { scheduledDeploymentsSelector } from "fleet/redux-store/scheduled-deployments/selectors";
import { ScheduledDeploymentListPageV2 } from "fleet/view/strategy-v2/schedule-deploy-list-v2.js";
import { ScheduledDeploymentListPage } from "fleet/view/strategy-v2/schedule-deploy-list.js";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { makeGetAllAsArray } from "redux-store/selectors";

const getAllDeploymentsAsArray = makeGetAllAsArray();

function mapStateToProps(state) {
  const scheduledDeployments = scheduledDeploymentsSelector(state);

  return {
    deployments: getAllDeploymentsAsArray({ byId: scheduledDeployments }),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    delete: (deploymentId) => {
      return createPromiseApiAction(dispatch, DELETE_SCHEDULED_DEPLOYMENT, [
        deploymentId,
      ]);
    },
  };
}

const ConnectedScheduledDeploymentList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ScheduledDeploymentListPage);

const ConnectedScheduledDeploymentListV2 = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ScheduledDeploymentListPageV2);

export { ConnectedScheduledDeploymentList, ConnectedScheduledDeploymentListV2 };
